import { TimelineMax } from 'gsap';

const $loader = $('.js-page-loader');

const $$animGroups = $('.js-start-anim-group');

const animations = [];

const prepareAnimations = () => {
    $$animGroups.each((i, el) => {
        const $$elems = $(el).find('.js-start-anim-el');
        const animation = new TimelineMax()
            .fromTo($$elems, 1, {y: 30, opacity: 0}, {y: 0, opacity: 1}, 0.25)
            .pause();
        
        animations.push(animation);
    });
};


const playAnimations = () => {
    animations.forEach(anim => {
        anim.play();
    });
};

const pageLoad = () => {
    prepareAnimations();
    $loader.fadeOut(1000, playAnimations);
};

export default pageLoad;